import { Link } from "react-router-dom";
import { useTranslation } from "@/services/i18n/client";
import { useAuth } from "@/lib/auth";
import { route, RouteKeys } from "@/services/routing/routes";

export function AppFooter() {
  const { t } = useTranslation("common");
  const { user, isLoaded } = useAuth();
  // The help center lives under the auth-gated /app subtree; showing the link
  // to anonymous visitors on public pages would bounce them to the sign-in wall.
  const isAuthenticated = isLoaded && user !== null;

  return (
    <footer className="border-t px-6 py-6 text-sm text-muted-foreground">
      <div className="mx-auto flex max-w-6xl flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p>
            &copy; {new Date().getFullYear()}{" "}
            {t("footer.copyright", "hey circle GmbH. All rights reserved.")}
          </p>
          <p className="mt-1">
            {t("footer.builtBy", "Built by")}{" "}
            <a
              href="https://chaysen.com"
              target="_blank"
              rel="noopener noreferrer"
              className="font-medium text-foreground underline underline-offset-4 hover:text-primary"
            >
              {t("footer.brandName", "Chays N Dreams")}
            </a>
          </p>
        </div>
        <nav className="flex gap-4">
          <Link
            to={route(RouteKeys.PRIVACY_POLICY)}
            className="underline underline-offset-4 hover:text-primary"
          >
            {t("footer.privacyPolicy", "Privacy Policy")}
          </Link>
          <Link
            to={route(RouteKeys.DATA_PRIVACY)}
            className="underline underline-offset-4 hover:text-primary"
          >
            {t("footer.dataPrivacy", "Data Privacy")}
          </Link>
          <Link
            to={route(RouteKeys.TERMS_OF_SERVICE)}
            className="underline underline-offset-4 hover:text-primary"
          >
            {t("footer.termsOfService", "Terms of Service")}
          </Link>
          {isAuthenticated && (
            <Link
              to={route(RouteKeys.HELP)}
              className="underline underline-offset-4 hover:text-primary"
            >
              {t("footer.helpCenter", "Help Center")}
            </Link>
          )}
        </nav>
      </div>
    </footer>
  );
}
